// Service item translations - keyed by original German name
// Only names are translated - prices/structure stay the same
export const SERVICE_ITEM_TRANSLATIONS = {
  // Angebote & Pakete
  "Fruchtsäurepeeling — 4er Paket": {
    de: "Fruchtsäurepeeling — 4er Paket",
    en: "Fruit Acid Peel — 4-Session Package",
    tr: "Meyve Asidi Peeling — 4'lü Paket",
  },
  "Microdermabrasion — 4er Paket": {
    de: "Microdermabrasion — 4er Paket",
    en: "Microdermabrasion — 4-Session Package",
    tr: "Mikrodermabrazyon — 4'lü Paket",
  },
  "Microneedling — 4er Paket": {
    de: "Microneedling — 4er Paket",
    en: "Microneedling — 4-Session Package",
    tr: "Microneedling — 4'lü Paket",
  },
  "Carbon Peeling — 4er Paket": {
    de: "Carbon Peeling — 4er Paket",
    en: "Carbon Peel — 4-Session Package",
    tr: "Karbon Peeling — 4'lü Paket",
  },
  "Botox 3 Zonen · 0,5 ml Hyaluron gratis": {
    de: "Botox 3 Zonen · 0,5 ml Hyaluron gratis",
    en: "Botox 3 zones · 0.5 ml hyaluron free",
    tr: "Botoks 3 bölge · 0,5 ml hyaluron hediye",
  },
  "Wellness Beauty Paket (Maniküre + Pediküre + Gesicht)": {
    de: "Wellness Beauty Paket (Maniküre + Pediküre + Gesicht)",
    en: "Wellness Beauty Package (Manicure + Pedicure + Facial)",
    tr: "Wellness Güzellik Paketi (Manikür + Pedikür + Yüz)",
  },
  "Wohlfühlzeit für Männer": {
    de: "Wohlfühlzeit für Männer",
    en: "Feel-good time for men",
    tr: "Erkekler için rahatlama zamanı",
  },

  // Ästhetik
  "Nasolabial 1 ml": { de: "Nasolabial 1 ml", en: "Nasolabial 1 ml", tr: "Nazolabial 1 ml" },
  "Nasenkorrektur": { de: "Nasenkorrektur", en: "Nose reshaping", tr: "Burun düzeltme" },
  "Wangenvolumen 1 ml": { de: "Wangenvolumen 1 ml", en: "Cheek volume 1 ml", tr: "Yanak dolgusu 1 ml" },
  "Kinnkorrektur 1 ml": { de: "Kinnkorrektur 1 ml", en: "Chin reshaping 1 ml", tr: "Çene düzeltme 1 ml" },
  "Augenring-Unterspritzung": {
    de: "Augenring-Unterspritzung",
    en: "Under-eye filler",
    tr: "Göz altı dolgusu",
  },
  "Lippen-Unterspritzung 1 ml": {
    de: "Lippen-Unterspritzung 1 ml",
    en: "Lip filler 1 ml",
    tr: "Dudak dolgusu 1 ml",
  },
  "Lemon Bottle Fettwegspritze": {
    de: "Lemon Bottle Fettwegspritze",
    en: "Lemon Bottle fat-dissolving injection",
    tr: "Lemon Bottle yağ eritme iğnesi",
  },

  // Gesicht
  "Pro Anti-Aging": { de: "Pro Anti-Aging", en: "Pro Anti-Aging", tr: "Pro Yaşlanma Karşıtı" },
  "Regenerierend · Akne": {
    de: "Regenerierend · Akne",
    en: "Regenerative · Acne",
    tr: "Yenileyici · Akne",
  },
  "Carbon Peeling": { de: "Carbon Peeling", en: "Carbon Peel", tr: "Karbon Peeling" },
  "Microneedling · Gesicht, Hals, Dekolleté": {
    de: "Microneedling · Gesicht, Hals, Dekolleté",
    en: "Microneedling · Face, Neck, Décolleté",
    tr: "Microneedling · Yüz, Boyun, Dekolte",
  },
  "Microdermabrasion": { de: "Microdermabrasion", en: "Microdermabrasion", tr: "Mikrodermabrazyon" },
  "Hydra Facial": { de: "Hydra Facial", en: "Hydra Facial", tr: "Hydra Facial" },
  "Fruchtsäurepeeling": { de: "Fruchtsäurepeeling", en: "Fruit Acid Peel", tr: "Meyve Asidi Peeling" },
  "Problemhaut / Unreine Haut": {
    de: "Problemhaut / Unreine Haut",
    en: "Problem / impure skin",
    tr: "Sorunlu / karma cilt",
  },
  "Klassische Gesichtsbehandlung": {
    de: "Klassische Gesichtsbehandlung",
    en: "Classic facial",
    tr: "Klasik yüz bakımı",
  },
  "Aloe Vera — Feuchtigkeit": {
    de: "Aloe Vera — Feuchtigkeit",
    en: "Aloe Vera — hydration",
    tr: "Aloe Vera — nemlendirme",
  },
  "Mesotherapie": { de: "Mesotherapie", en: "Mesotherapy", tr: "Mezoterapi" },
  "Microneedling mit Fruchtsäure": {
    de: "Microneedling mit Fruchtsäure",
    en: "Microneedling with fruit acid",
    tr: "Meyve asidi ile Microneedling",
  },
  "Carbon Peeling mit Fruchtsäure": {
    de: "Carbon Peeling mit Fruchtsäure",
    en: "Carbon peel with fruit acid",
    tr: "Meyve asidi ile karbon peeling",
  },
  "Glow Peel": { de: "Glow Peel", en: "Glow Peel", tr: "Glow Peel" },
  "Hautanalyse": { de: "Hautanalyse", en: "Skin analysis", tr: "Cilt analizi" },
  "Zahnbleaching": { de: "Zahnbleaching", en: "Teeth whitening", tr: "Diş beyazlatma" },

  // Körper
  "Körperbehandlung — Akne": {
    de: "Körperbehandlung — Akne",
    en: "Body treatment — acne",
    tr: "Vücut bakımı — akne",
  },
  "Körperbehandlung — Rücken": {
    de: "Körperbehandlung — Rücken",
    en: "Body treatment — back",
    tr: "Vücut bakımı — sırt",
  },
  "Ohrkerzenbehandlung": { de: "Ohrkerzenbehandlung", en: "Ear candle treatment", tr: "Kulak mumu tedavisi" },
  "Plasma Pen": { de: "Plasma Pen", en: "Plasma Pen", tr: "Plazma Pen" },
  "Warzen- / Muttermal-Entfernung": {
    de: "Warzen- / Muttermal-Entfernung",
    en: "Wart / mole removal",
    tr: "Siğil / ben aldırma",
  },
  "Waxing Gesicht · Achsel · Arme · Beine": {
    de: "Waxing Gesicht · Achsel · Arme · Beine",
    en: "Waxing face · underarm · arms · legs",
    tr: "Ağda yüz · koltuk altı · kol · bacak",
  },
  "Vitamin C Infusion": { de: "Vitamin C Infusion", en: "Vitamin C infusion", tr: "C Vitamini serumu" },
  "Vitamin B12 Infusion": { de: "Vitamin B12 Infusion", en: "Vitamin B12 infusion", tr: "B12 Vitamini serumu" },

  // Waxing
  "Waxing — Gesicht komplett": {
    de: "Waxing — Gesicht komplett",
    en: "Waxing — full face",
    tr: "Ağda — tüm yüz",
  },
  "Waxing — Oberlippe": { de: "Waxing — Oberlippe", en: "Waxing — upper lip", tr: "Ağda — üst dudak" },
  "Waxing — Kinn": { de: "Waxing — Kinn", en: "Waxing — chin", tr: "Ağda — çene" },
  "Waxing — Ohren": { de: "Waxing — Ohren", en: "Waxing — ears", tr: "Ağda — kulak" },
  "Waxing — Schultern": { de: "Waxing — Schultern", en: "Waxing — shoulders", tr: "Ağda — omuz" },

  // Nägel
  "Maniküre ohne Lack": { de: "Maniküre ohne Lack", en: "Manicure without polish", tr: "Ojesiz manikür" },
  "Maniküre mit Lack": { de: "Maniküre mit Lack", en: "Manicure with polish", tr: "Ojeli manikür" },
  "Maniküre mit Gellack / Shellac": {
    de: "Maniküre mit Gellack / Shellac",
    en: "Manicure with gel polish / Shellac",
    tr: "Kalıcı oje / Shellac manikür",
  },
  "Maniküre mit Paraffinbad": {
    de: "Maniküre mit Paraffinbad",
    en: "Manicure with paraffin bath",
    tr: "Parafin banyolu manikür",
  },
  "Pediküre": { de: "Pediküre", en: "Pedicure", tr: "Pedikür" },
  "Pediküre mit Lack": { de: "Pediküre mit Lack", en: "Pedicure with polish", tr: "Ojeli pedikür" },
  "Pediküre mit Gellack / Shellac": {
    de: "Pediküre mit Gellack / Shellac",
    en: "Pedicure with gel polish / Shellac",
    tr: "Kalıcı oje / Shellac pedikür",
  },
  "Medizinische Fußpflege": { de: "Medizinische Fußpflege", en: "Medical pedicure", tr: "Medikal ayak bakımı" },
  "Med. Fußpflege mit Paraffinbad": {
    de: "Med. Fußpflege mit Paraffinbad",
    en: "Medical pedicure with paraffin",
    tr: "Parafinli medikal ayak bakımı",
  },
  "Nagelmodellage — Neues Set Pulver Gel": {
    de: "Nagelmodellage — Neues Set Pulver Gel",
    en: "Nail modeling — new set powder gel",
    tr: "Tırnak modelleme — yeni set pudra jel",
  },
  "Nagelmodellage — Auffüllen mit Acryl": {
    de: "Nagelmodellage — Auffüllen mit Acryl",
    en: "Nail modeling — refill acrylic",
    tr: "Tırnak dolgu — akrilik",
  },
  "Nagelmodellage — Auffüllen mit Gel": {
    de: "Nagelmodellage — Auffüllen mit Gel",
    en: "Nail modeling — refill gel",
    tr: "Tırnak dolgu — jel",
  },
  "Nagelmodellage — Entfernen + Maniküre": {
    de: "Nagelmodellage — Entfernen + Maniküre",
    en: "Nail removal + manicure",
    tr: "Tırnak söküm + manikür",
  },
  "Naturnagelverstärkung": {
    de: "Naturnagelverstärkung",
    en: "Natural nail strengthening",
    tr: "Doğal tırnak güçlendirme",
  },
  "Naturnagelverstärkung inkl. Maniküre": {
    de: "Naturnagelverstärkung inkl. Maniküre",
    en: "Natural nail strengthening incl. manicure",
    tr: "Manikür dahil doğal tırnak güçlendirme",
  },
  "Nagelmodellage": { de: "Nagelmodellage", en: "Nail modeling", tr: "Tırnak modelleme" },
  "Baby Boomer Auffüllen": { de: "Baby Boomer Auffüllen", en: "Baby Boomer refill", tr: "Baby Boomer dolgu" },
  "Airbrush Nails Auffüllen": {
    de: "Airbrush Nails Auffüllen",
    en: "Airbrush nails refill",
    tr: "Airbrush tırnak dolgusu",
  },
  "Nagelreparatur bei Gelmodellage": {
    de: "Nagelreparatur bei Gelmodellage",
    en: "Nail repair (gel)",
    tr: "Jel tırnak onarımı",
  },
  "Nagellack-Entfernung Hände oder Füße": {
    de: "Nagellack-Entfernung Hände oder Füße",
    en: "Nail polish removal (hands or feet)",
    tr: "Oje çıkarma (el veya ayak)",
  },

  // Wimpern / Augenbrauen
  "Wimpernverlängerung — Neuanlage 1:1": {
    de: "Wimpernverlängerung — Neuanlage 1:1",
    en: "Lash extensions — new set 1:1",
    tr: "Kirpik uzatma — yeni set 1:1",
  },
  "Wimpernverlängerung — Neuanlage 2D": {
    de: "Wimpernverlängerung — Neuanlage 2D",
    en: "Lash extensions — new set 2D",
    tr: "Kirpik uzatma — yeni set 2D",
  },
  "Wimpern Refill": { de: "Wimpern Refill", en: "Lash refill", tr: "Kirpik dolgu" },
  "Wimpernlifting": { de: "Wimpernlifting", en: "Lash lift", tr: "Kirpik lifting" },
  "Wimpern färben": { de: "Wimpern färben", en: "Lash tint", tr: "Kirpik boyama" },
  "Augenbrauen": { de: "Augenbrauen", en: "Brows", tr: "Kaş" },
  "Augenbrauen zupfen": { de: "Augenbrauen zupfen", en: "Brow tweezing", tr: "Kaş alma" },
  "Augenbrauenkorrektur": { de: "Augenbrauenkorrektur", en: "Brow correction", tr: "Kaş düzeltme" },
  "Augenbrauenlifting": { de: "Augenbrauenlifting", en: "Brow lift", tr: "Kaş lifting" },
  "Augenbrauen & Wimpern färben": {
    de: "Augenbrauen & Wimpern färben",
    en: "Brow & lash tint",
    tr: "Kaş & kirpik boyama",
  },

  // Hair services
  "Trockenschnitt": { de: "Trockenschnitt", en: "Dry cut", tr: "Kuru kesim" },
  "Waschen · Schneiden · Trocknen": {
    de: "Waschen · Schneiden · Trocknen",
    en: "Wash · Cut · Dry",
    tr: "Yıkama · Kesim · Kurutma",
  },
  "Waschen · Schneiden · Föhnen": {
    de: "Waschen · Schneiden · Föhnen",
    en: "Wash · Cut · Blow-dry",
    tr: "Yıkama · Kesim · Fön",
  },
  "Färben inkl. Pflege": { de: "Färben inkl. Pflege", en: "Color incl. care", tr: "Boya (bakım dahil)" },
  "Tönen inkl. Pflege": { de: "Tönen inkl. Pflege", en: "Tint incl. care", tr: "Renk açma (bakım dahil)" },
  "Strähnen Halbkopf inkl. Pflege": {
    de: "Strähnen Halbkopf inkl. Pflege",
    en: "Half-head highlights incl. care",
    tr: "Yarım röfle (bakım dahil)",
  },
  "Strähnen Ganzkopf inkl. Pflege": {
    de: "Strähnen Ganzkopf inkl. Pflege",
    en: "Full-head highlights incl. care",
    tr: "Tam röfle (bakım dahil)",
  },
  "Paar Folien": { de: "Paar Folien", en: "A few foils", tr: "Birkaç folyo" },
  "Keratin-Behandlung · Kurz (Haarglättung)": {
    de: "Keratin-Behandlung · Kurz (Haarglättung)",
    en: "Keratin treatment · short (straightening)",
    tr: "Keratin bakımı · kısa (düzleştirme)",
  },
  "Keratin-Behandlung · Mittel": {
    de: "Keratin-Behandlung · Mittel",
    en: "Keratin treatment · medium",
    tr: "Keratin bakımı · orta",
  },
  "Keratin-Behandlung · Lang": {
    de: "Keratin-Behandlung · Lang",
    en: "Keratin treatment · long",
    tr: "Keratin bakımı · uzun",
  },
  "Ohrenwachsreinigung": { de: "Ohrenwachsreinigung", en: "Ear wax cleaning", tr: "Kulak temizliği" },
  "Braut-Frisur inkl. Make-up": {
    de: "Braut-Frisur inkl. Make-up",
    en: "Bridal hair incl. make-up",
    tr: "Gelin saçı (makyaj dahil)",
  },
  "Waschen · Schneiden · Stylen": {
    de: "Waschen · Schneiden · Stylen",
    en: "Wash · Cut · Style",
    tr: "Yıkama · Kesim · Şekillendirme",
  },
  "Schneiden bis 5 Jahre": {
    de: "Schneiden bis 5 Jahre",
    en: "Cut up to 5 years",
    tr: "5 yaşa kadar kesim",
  },
  "Schneiden inkl. Stylen": {
    de: "Schneiden inkl. Stylen",
    en: "Cut incl. styling",
    tr: "Kesim (stil dahil)",
  },
};

// Price translations (ab / ca. / bis)
export const translatePrice = (price, lang) => {
  if (!price) return price;
  if (lang === "de") return price;
  const map = {
    en: { ab: "from", "ca.": "approx.", bis: "up to" },
    tr: { ab: "başlangıç", "ca.": "yaklaşık", bis: "e kadar" },
  };
  const rules = map[lang] || map.en;
  return price
    .replace(/^ab\s/i, `${rules.ab} `)
    .replace(/^ca\.\s/i, `${rules["ca."]} `)
    .replace(/^bis\s/i, `${rules.bis} `);
};
